import {
  Flex,
  PaginationProvider,
  SortProvider,
  SearchProvider,
  FormProvider,
  ModalProvider,
} from 'dash-ui';
import PropertyInventoryTableHeader from 'containers/properties/PropertyInventory/components/PropertyInventoryTableHeader/PropertyInventoryTableHeader';
import PropertyInventoryTable from 'containers/properties/PropertyInventory/components/PropertyInventoryTable/PropertyInventoryTable';
import AddPropertyInventoryModal from 'containers/properties/PropertyInventory/components/AddPropertyInventoryModal/AddPropertyInventoryModal';

import { GetPropertyByIdQuery } from 'gql/generated.graphql';
import { FormFieldsList } from './components/AddPropertyInventoryModal/constants/constants';
import DeleteInventoryModal from './components/DeleteInventoryModal/DeleteInventoryModal';

function Properties({
  property,
}: {
  property: GetPropertyByIdQuery['getPropertyById'];
}) {
  return (
    <PaginationProvider>
      <SortProvider>
        <SearchProvider>
          <ModalProvider>
            <Flex flexDirection="column" flex={1} w="100%">
              <PropertyInventoryTableHeader />
              <PropertyInventoryTable filter={{ propertyId: property._id }} />
              <FormProvider fieldsList={FormFieldsList}>
                <AddPropertyInventoryModal property={property} />
              </FormProvider>
              <DeleteInventoryModal />
            </Flex>
          </ModalProvider>
        </SearchProvider>
      </SortProvider>
    </PaginationProvider>
  );
}

export default Properties;
